var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.tooltip),expression:"tooltip"}],staticClass:"app-dotnotification",class:_vm.bg,style:({ 
    borderRadius: (_vm.borderRadius + "px"),
    width: (_vm.size + "px"),
    height: (_vm.size + "px"),
  })})}
var staticRenderFns = []

export { render, staticRenderFns }